export class HomeJSONIDService {
  public HomeBusiness = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "iQuanta",
  "image": "https://media.iquanta.in/ui_images/new-dashboard/favicon-32x32.png",
  "url": "https://www.iquanta.in/",
  "telephone": "+917683043155",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Ground Floor, 126, Udyog Vihar Phase 4 Rd, Phase III, Udyog Vihar, Sector 19",
    "addressLocality": "Gurugram",
    "postalCode": "122022",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 28.494521777065867,
    "longitude": 77.07957645211637
  },
  "priceRange": "51,499",
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ],
    "opens": "00:00",
    "closes": "23:59"
  },
  "sameAs": [
    "https://facebook.com/iquanta.in",
    "https://www.instagram.com/iquanta.in/",
    "https://www.youtube.com/@CatpreparationiQuanta",
    "https://in.linkedin.com/company/iquanta-edu-services"
  ]
}

  public HomeOrganization =  {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "iQuanta",
  "alternateName": "iQuanta Edu",
  "url": "https://www.iquanta.in/",
  "logo": "https://media.iquanta.in/ui_images/new-dashboard/favicon-32x32.png",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "7683043155",
    "contactType": "customer service",
    "contactOption": "TollFree",
    "areaServed": "IN",
    "availableLanguage": ["en","Hindi"]
  },
  "sameAs": [
    "https://facebook.com/iquanta.in",
    "https://www.instagram.com/iquanta.in/",
    "https://www.youtube.com/@CatpreparationiQuanta",
    "https://in.linkedin.com/company/iquanta-edu-services"
  ]
}

  public HomePerson = {
  "@context": "https://schema.org/",
  "@type": "Person",
  "name": "Indrajeet Singh",
  "url": "https://www.iquanta.in/",
  "image": "https://media.iquanta.in/ui_images/public_portal_img/ava.jpg",
  "sameAs": [
    "https://www.facebook.com/IndrajeetiQuanta",
    "https://www.linkedin.com/in/indralion/"
  ],
  "jobTitle": "CEO",
  "worksFor": {
    "@type": "Organization",
    "name": "iQuanta"
  }
}

public HomeFAQ = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "Which CAT course is best for non-engineers to prepare for CAT 2025?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can go for iQuanta flagship course CAT 2025 Full Course or the CAT 2025 Pro Batch. These courses provide conceptual videos for non-engineers, for those who are extremely weak in quant, and After completion of each topic, there is a marathon that carries questions of CAT 2023. We provide a topic-wise CAT mock test, 50 Questions on each Topic as Study Material and 10 + Sets of Hardcopy CAT Material as per the Updated Pattern (5000 Questions). The Course has 250+ Recorded Videos and practice sessions after each class along with 24x7 instant doubt support."
    }
  },{
    "@type": "Question",
    "name": "Is it necessary to opt for any CAT coaching?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "It depends on individual hard work and practice but having a mentor beside you can help you crack the exam easily. iQuanta is the best when it comes to content, study material or doubt resolution."
    }
  },{
    "@type": "Question",
    "name": "When should I join a CAT course?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Generally, there is no right time to join any CAT course. You can go for it while in college or after graduation depending on when you want to do your MBA."
    }
  },{
    "@type": "Question",
    "name": "Should I self-prepare or go with a CAT coaching?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can go with either depending on how familiar you are with aptitude tests. But the best combination would be CAT coaching along with self-study. Coaching will simplify your hunt for study material and structure your preparation. iQuanta’s CAT Course also ensures that all your doubts and instantly resolved. Meanwhile, self-practicing will help you in getting familiar with all types of questions."
    }
  },{
    "@type": "Question",
    "name": "Is CAT online coaching a good idea?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "CAT online coaching is pocket-friendly and easily accessible according to student convenience. It saves time as well as energy for students. iQuanta provides several online CAT courses which makes learning easy. You can go for the iQuanta CAT 2025 full course which involves conceptual videos for non-engineering students, topic-wise tests, assignments, full CAT mocks and a Crash Course in addition to a Live & application class with 24x7 doubt assistance."
    }
  },{
    "@type": "Question",
    "name": "Which CAT online coaching is helpful if I am weak in Quants?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "iQuanta’s CAT course is the right choice as it has a customised module for those who are extremely weak in Mathematics. This module is in alignment with the NCERT class 6-10 syllabus. So if you have lost touch with Mathematics or have not studied Maths after class 12 then this module is definitely for you. The Quant section has basic Maths that we have studied in class 6 to 10 such as number system, average, ratio & proportion, profit & loss, probability, geometry, time, work & distance, etc. So you will be taught all the topics from the basic concepts itself. So the iQuanta CAT course is really helpful for you if you are struggling with Mathematics."
    }
  }]
}

public membersList: any[] = [
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory1.png',
      name: 'Gursimran Ahuja,  IIM Ahmedabad',
      subtext: 'CAT Percentile : 99.83',
      story: 'Being active in your online CAT course and learning from other students’ doubts or approach can help you avoid mistakes and enable you to solve questions faster  , and I have iQuanta to thank for providing me that platform from where I could amplify my achievements in the given amount of time to a great extent',
      link: 'https://www.iquanta.in/blog/cat-tips-by-gursimran-ahuja-iim-abc-convert/',
      percent: '99.83',
      title: 'CAT Percentile',
      titlename:'Gursimran Ahuja',
      college: 'IIM Ahmedabad'
    },
    {
      img: 'https://media.iquanta.in/ui_images/successstory2.webp',
      name: 'Shikhar Sachdeva , IIM Ahmedabad',
      subtext: 'CAT Percentile : 99.98',
      story: "How can I even begin to thank the mentor Indrajeet Singh, who was there at each step of the journey to guide me, and to show me the right direction. It's been a wonderful journey so far. Hope it ends in the best possible manner.",
      link: 'https://www.iquanta.in/blog/my-journey-to-success-topping-cat-exam/',
        percent: '99.98',
      title: 'CAT Percentile',
        titlename:'Shikhar Sachdeva',
      college: 'IIM Ahmedabad'
    },
    {
      img: 'https://media.iquanta.in/ui_images/successstory3.webp',
      name: 'Sahil Aggarwal, IIM Ahmedabad',
      subtext: 'CAT Percentile : 99.76',
      story: "As there were time limitations to prepare along with the job I decided to rely on iQuanta course for quant. My quant showed significant improvement and was fortunate to score 99.76 percentile in CAT 17 and 99.67 percentile in XAT 18.Message for Indrajeet sir: Personally I found this to be the best material for quant preparation for CAT which ideally suited my preparation style. Thank you for the course sir, keep helping and motivating the students coming through.",
      link: 'https://www.iquanta.in/blog/story-of-an-iim-abc-convert-an-iquanta-student/',
        percent: '99.76',
      title: 'CAT Percentile',
        titlename:'Sahil Aggarwal',
      college: 'IIM Ahmedabad'
    },
    {
      img: 'https://media.iquanta.in/ui_images/successstory4.webp',
      name: 'Biswanath Chakraborty, IIM Bangalore',
      subtext: 'CAT Percentile : 99.06',
      story: "The journey started with cat preparation 2 years back , with me practising with stalwarts here of the previous batch. It has been an amazing journey with iQuanta .The immense pool of knowledge that this group shares is exemplary. Indrajeet sirjee you have been an inspiration , with constant tutelage you gave us just the right impetus. Alas vastrapur was not meant to be but thankfully I could crack IIM B. For the upcoming cat , I would say just stay focused, practice hard and remember sky is the limit. Thank you everyone ,will miss you .",
      link: 'https://www.iquanta.in/blog/converted-iim-bangalore-as-a-fresher-bursting-the-myth-biswanath-chakraborty/',
        percent: '99.06',
      title: 'CAT Percentile',
        titlename:'Biswanath Chakraborty',
      college: 'IIM Bangalore'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory5.png',
      name: 'Debarshee Mitra , IIM Calcutta',
      subtext: 'CAT Percentile : 99.70',
      story: "Thank you so much Indrajeet. I still remember in September when I was still solving arun sharma and realized that I couldn't solve half the questions posted on the group that I decided to join iquanta. Ended up with 99.86 in quant(should have been more). Every topic being revised more than I did even for my 10th boards and the results are there for all to see. Thank you again, it has been a pleasure.",
      link: 'https://www.iquanta.in/blog/success-story-of-debashree-mitra-iim-calcutta-convert/',
        percent: '99.70',
      title: 'CAT Percentile',
        titlename:'Debarshee Mitra',
      college: 'IIM Calcutta'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory6.png',
      name: 'Akshat Jain, IIM Bangalore',
      subtext: 'CAT Percentile : 99.82',
      story: "I think that Indrajeet’s shortcuts and tricks are very useful and come handy during the exam. From personal experience, I think there were 2-3 questions of Quantitative Aptitude which were pretty direct and could be solved using just his formulas.",
      link: 'https://www.iquanta.in/blog/the-cat-success-story-of-akshat/',
        percent: '99.82',
      title: 'CAT Percentile',
        titlename:'Akshat Jain',
      college: 'IIM Bangalore'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory7.png',
      name: 'Pratik Ranjan',
      subtext: 'IIM Lucknow',
      story: "I think Indrajeet sir is doing a great job with the amazing tips and shortcuts. I joined the crash course provided by iQuanta which helped me with a quick revision of everything and it helped me to a great extent.",
      link: 'https://www.iquanta.in/blog/preparation-strategy-of-iim-l-convert-prateek-ranjan/',
        percent: '99.83',
      title: 'IIM Lucknow',
        titlename:'Pratik Ranjan',
      college: 'IIM Lucknow'
    },
    {
      img: 'https://media.iquanta.in/ui_images/successstory8.webp',
      name: 'Shweta Arya',
      subtext: 'IIM Shillong',
      story: "I think iQuanta CAT online coaching is a pre-requisite to nail any management exam. It helped me strengthen my weaker sections and also improve my scores in my stronger sections.",
      link: 'https://www.iquanta.in/blog/cat-story-shweta-arya-calls-iift-sibm-p-nmims-iim-s-tiss/',
         percent: '99.83',
      title: 'IIM Shillong',
        titlename:'Shweta Arya',
      college: 'IIM Shillong'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory9.png',
      name: 'Arpit Behl ',
      subtext: 'MDI, Gurgaon ',
      story: "iQuanta played a leading role in my success. With the help of Indrajeet Sir in Quant- my stronger section, I scored a sectional score of 98.79%ile in Quant. I was not scoring in this section before. His shortcuts and methodology are excellent.",
      link: 'https://www.iquanta.in/blog/arpit-behl-how-iquanta-helped-me-ace-cat/',
         percent: '98.9',
      title: 'MDI, Gurgaon ',
        titlename:'Arpit Behl',
      college: 'MDI, Gurgaon'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory10.png',
      name: 'Shubham Varshney',
      subtext: 'IIM Ahmedabad',
      story: "When offline coaching ditched us, then iQuanta’s CAT online classes came to the rescue. Thanks a lot Indrajeet!",
      link: '',
       percent: '99.83',
      title: 'IIM Ahmedabad',
        titlename:'Shubham Varshney',
      college: 'IIM Ahmedabad'
    }

  ]

  public  courseComparison1: any[] = [
    {
      text: 'Live Conceptual Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: 'Application Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'All Year Practice Sessions', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Assignments', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: '24*7 Doubt Solving', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Full Mocks with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: 'Sectionals with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "Non-Engineer's Quants Videos", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "Engineer's VARC Videos", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'CAT LRDI Inception', colorText: " ", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'AI Mock Analysis', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Special initiatives (QA250,LRDI70)', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Peer to Peer Learning', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Free 2 Month Crash Course', colorText: ' ', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: '7500 CAT Qs IIM ABC Course', colorText: '', subText: '', img1: '',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'IIM ABC Practice Sessions', colorText: '', subText: '(Daily 12 QA, 3 RCs & 3 LRDI Sets)', img1: '',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "12 Sets: CAT'24 level Books", colorText: '', subText: '', img1: '',
      img2: '', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
  ]

}